import ProductLandingTemplate from "./ProductLandingTemplate";

const product = {
  slug: "nyugdijbiztositas",
  name: "Nyugdíjbiztosítás",
  description:
    "Tervezd meg nyugdíjcélú megtakarításodat, és használd ki az állami adójóváírás adta lehetőségeket.",
  highlights: [
    "20% adójóváírás lehetősége",
    "Hosszú távú, tudatos pénzügyi tervezés",
    "Kockázathoz illeszkedő konstrukciók",
  ],
};

export default function NyugdijbiztositasPage() {
  return (
    <ProductLandingTemplate
      product={product}
      iframeSrc="https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel"
    />
  );
}
